import { ChangeRoute } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';

/**
 * Skutki wyborów operatora w kroku W2: trasa paczki rozstrzyga o tym, czy
 * dokumenty w ogóle mają komu trafić do podpisu.
 */

/**
 * Trasa „Wprowadź od razu” pomija krok akceptacji, więc nie ma komu podpisać
 * dokumentów — cała sekcja znika zamiast stać wygaszona i mylić operatora.
 */
export const areDocumentsRelevant = (route: ChangeRoute): boolean =>
  route === ChangeRoute.CLIENT_ACCEPTANCE;
